// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__7ljJb","prev":"style_prev__CdsVd","next":"style_next__CpTel","container2":"style_container2__ce1JX"};